import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import QueryString from 'query-string';
import Loader from '../../../components/commons/loader/loader';
import SweetAlert from 'sweetalert-react';
import * as UserActions from '../../../actions/userActions';
import {
  FacebookLoginButton,
  GoogleLoginButton
} from "react-social-login-buttons";

import * as FBinit from '../../../utils/fbintit';
import * as GoogleInit from '../../../utils/googleOauth';
class LoginPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      userId: '',
      password: '',
      showAlert: false,
      swalParams: {
        title: ''
      }
    }

    this.handelKeyPress = this.handelKeyPress.bind(this);
    this.login = this.login.bind(this);
    this.loginFB = this.loginFB.bind(this);
    this.loginGoogle = this.loginGoogle.bind(this);
    this.checkForBirthdayWall = this.checkForBirthdayWall.bind(this);
  }

  componentDidMount() {

    const { location } = this.props;
    let params = QueryString.parse(location.search);

    if (params.auth && params.auth === 'required') {
      this.setState({
        showAlert: true, swalParams: {
          title: "Please login to continue!",
          type: "warning",
          showConfirmButton: false
        }
      })
    }

    window.onkeydown = null;
  }

  handelKeyPress(event) {
    if (event.nativeEvent.keyCode == 13) {
      this.login()
    }

  }


  render() {

    //console.log("LOGIN_PAGE_STATE", this.state);
    console.log("LOGIN_PAGE_PROPS", this.props);
    const { loading } = this.props;
    const { swalParams, showAlert } = this.state;

    return (
      <div className="page auth-page login-page">
        <div className="auth-wrapper">
          <div className="auth-header">
            <h1>Continue to Checkout</h1>
            <p>Sign in to your account or create a new one</p>
          </div>

          <div className="auth-card">
            <div className="auth-tabs">
              <Link to="/signin" className="auth-tab active">Sign In</Link>
              <Link to="/signup" className="auth-tab">Create Account</Link>
            </div>

            <div className="auth-form">
              <div className="auth-field">
                <label htmlFor="user">EMAIL ADDRESS</label>
                <input
                  id="user"
                  name="user"
                  aria-label="Email Address"
                  placeholder="Enter your email"
                  className="auth-input"
                  onChange={(e) => this.setState({ userId: e.target.value })}
                  onKeyPress={(event) => this.handelKeyPress(event)}
                />
              </div>

              <div className="auth-field">
                <label htmlFor="password">PASSWORD</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  aria-label="password"
                  placeholder="Enter your password"
                  className="auth-input"
                  onChange={(e) => this.setState({ password: e.target.value })}
                  onKeyPress={(event) => this.handelKeyPress(event)}
                />
                <div className="auth-inline-link">
                  <Link to="/forgot-password">Forgot password?</Link>
                </div>
              </div>

              <button type="button" className="auth-primary-btn" onClick={() => this.login()}>
                SIGN IN &amp; CONTINUE
              </button>

              <div className="auth-divider">
                <span>or continue with</span>
              </div>

              <div className="auth-social">
                <GoogleLoginButton className="auth-social-btn google-btn" align={"center"} onClick={(e) => this.loginGoogle(e)} >
                  <span>Sign in with Google</span>
                </GoogleLoginButton>
                <FacebookLoginButton className="auth-social-btn facebook-btn" align={"center"} onClick={(e) => this.loginFB(e)} >
                  <span>Sign in with Facebook</span>
                </FacebookLoginButton>
              </div>

              <div className="auth-switch-link">Don't have an account yet?&nbsp;
                <Link to="/signup" className="bold underlined">Register to proceed</Link>
              </div>
            </div>
          </div>

          <div className="auth-footer-links">
            <Link to="/" className="underlined">Continue Shopping</Link>
          </div>
        </div>
        <Loader visibility={loading} />
        <SweetAlert customClass={"with-close"} showCancelButton cancelButtonText={"x"} onCancel={()=> this.setState({showAlert:false})} show={showAlert} {...swalParams} onConfirm={() => this.setState({showAlert: false})}/>
      </div>
    )
  }


  
  async loginGoogle(e){

    e.preventDefault();
    try {
      
    let data = await GoogleInit.promptLogin();
    
    this.props.dispatch(UserActions.googlelogin(data, response => {

      this.checkForBirthdayWall(response);
    
      
    }))
    } catch (error) {
      console.error(error);
    }
    
  }
  async loginFB(e){
      e.preventDefault();
      const data = await FBinit.FbLogin();
      if(data.authResponse==null){
        return;
      }
      this.props.dispatch(UserActions.fblogin({accessToken:data.authResponse.accessToken,userID:data.authResponse.userID}, response => {
      this.checkForBirthdayWall(response);
        
     
        
      }))
    }

    checkForBirthdayWall(response){

      this.props.dispatch(UserActions.getProfileDetails());//to get the address
      if (response.status) {
        if(response.data.dob=="1000-12-01"){
        
          this.props.history.push('/birthday-wall');
          return;
        }
        this.props.history.push('/');
      } else {
        let error = response.data.message
          ? response.data.message
          : "Something went wrong, try again later!";
        this.setState({showAlert: true, swalParams: {
          title: error,
          type: "error",
          showConfirmButton: false
        }})
        
      }
    }
  login() {

    const {userId, password} = this.state;
    this.props.dispatch(UserActions.login({
      email: userId,
      password: password
    }, response => {
      this.checkForBirthdayWall(response);
    }))
  }
}

  export default connect((state) => {
    return {
      loading: state.getIn(['users', 'loading']),
      error: state.getIn(['users', 'error'])
    };
  })(LoginPage);



// WEBPACK FOOTER //
// ./src/containers/begin/login/LoginPage.js